import { ConsignaAction, CotizaAction, NvvAction, PurchaseAction, ReservaAction } from '../enums/DocActions'
import { AppPath } from '../enums/AppPath'

import DocConfirma from './DocConfirma'
import InputTextArea from './InputTextArea'

/* Reusable Anular documento . Usado en Estimates y otros.
 */
const DocAnula: React.FC<{
  label: string
  header: string
  name: string
  value?: string
  docType: AppPath
  loading?: boolean

  handleInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  handleButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}> = ({ label, header, name, value, docType, loading, handleInputChange, handleButtonClick }) => {
  let action = -1

  switch (docType) {
    case AppPath.SaleNotes:
      action = NvvAction.Anular
      break

    case AppPath.Consignments:
      action = ConsignaAction.Anular
      break

    case AppPath.Estimates:
      action = CotizaAction.Anular
      break
    case AppPath.Reservations:
      action = ReservaAction.Anular
      break
    case AppPath.Settlements:
      action = PurchaseAction.Anular
      break
  }

  return (
    <>
      <span>{header}</span>
      <InputTextArea label={label} name={name} value={value} handleInputChange={handleInputChange} />
      <DocConfirma docType={docType} handleCrearClick={handleButtonClick} action={action} loading={loading} />
    </>
  )
}
export default DocAnula
